import { Box, DropdownButton } from '@dixa/lib-shared-habla';

import { PresenceControls } from 'components/presence/components/presenceControls';
import { PresenceControlsProps } from 'components/presence/components/presenceControls/presenceControls';

import styles from './presencePopover.module.scss';

export const PresencePopover = ({
  user,
  presence,
}: PresenceControlsProps): JSX.Element => {
  // We need to destroyOnClose to avoid presence controls from keeping their state
  // and changing the state for an incorrect agent

  return (
    <DropdownButton
      data-dropdown-button={true}
      dropdown={
        <Box className={styles.contentContainer}>
          <PresenceControls user={user} presence={presence} />
        </Box>
      }
      destroyOnClose
      buttonProps={{ variant: 'tertiary' }}
      icon="circle-dashed"
    />
  );
};
